<template>
    <b-form-group :label="label" :description="description" :invalid-feedback="error" :state="state">
        <form-input-group :left-icon="leftIcon">
            <b-input-group-prepend is-text v-if="leftButton">
                <slot name="leftButton"></slot>
            </b-input-group-prepend>
            <b-form-textarea
                v-on="listeners"
                v-bind="attrs"
                :value="value"
                :state="state"
                :placeholder="floatingLabel || placeholder"
                :class="['rounded-right', floatingLabel ? 'floating-label' : '']"
                @input="input"
            ></b-form-textarea>
            <label :if="floatingLabel" :style="{ left: leftIcon ? '3.2rem' : '' }">{{ floatingLabel }}</label>
        </form-input-group>
    </b-form-group>
</template>

<script>
    import { formFieldMixin } from '../../../mixins/form-field-mixin';
    import FormInputGroup from '../form-input-group/form-input-group.vue';

    export default {
        name: 'FormInput',
        mixins: [formFieldMixin],
        components: {
            FormInputGroup,
        },
        props: {
            value: [String, Number],
            leftIcon: [Object, Array, String],
            floatingLabel: [String, Number],
            placeholder: [String, Number],
            leftButton: Boolean,
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../mixins.scss';
    @import '../../../variables.scss';

    @mixin activeLabel() {
        z-index: 99;
        font-size: 0.8rem;
        line-height: 1.1;
        padding: 0.1rem;
        color: $floating-label-color-active;
        font-weight: $floating-label-font-weight;
    }

    @mixin activeInput() {
        padding-bottom: 0.1rem;
        padding-top: 1rem;
        z-index: inherit;
        height: initial;
    }

    textarea.floating-label {
        @include transition(all ease-in-out 0.2s);
        @include disablePlaceholder;

        & ~ label {
            @include transition(all ease-in-out 0.2s);
            position: absolute;
            user-select: none;
            padding: 0.3rem 0.2rem;
            font-size: 1rem;
            line-height: 1.5;
            color: $floating-label-placeholder-color;
            pointer-events: none;
            top: 0.1rem;
            left: 0.7rem;
            margin: 0;
        }
    }

    textarea.floating-label:focus {
        @include activeInput;
        @include disablePlaceholder;

        ~ label {
            @include activeLabel;
        }
    }

    textarea.floating-label:not(:placeholder-shown),
    textarea.floating-label:focus:not(:placeholder-shown) {
        @include activeInput;
    }

    textarea.floating-label:not(:placeholder-shown) ~ label,
    textarea.floating-label:focus:not(:placeholder-shown) ~ label {
        @include activeLabel;
    }
</style>
